import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import DashboardSidebarMain from "../../dashsidebar";

function DashboardVendorList() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    vendor_name: "",
    email: "",
    phone: "",
    category: "Spices & Aromatics",
    company_address: "",
    commission_rate: "10",
    pan_number: "",
    gstin: "",
    artisan_cert: null
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.vendor_name || !formData.email || !formData.phone) {
      toast.error("Please fill in all mandatory fields.");
      return;
    }

    toast.success("Artisan Cooperative Registered successfully! Redirecting...", {
      position: "top-right",
      autoClose: 2000,
      onClose: () => navigate("/dash-vendor")
    });
  };

  return (
    <>
      <ToastContainer />
      <DashboardContainer>
        <DashboardSidebarMain />
        <MainPanel>
          <HeaderRow>
            <div>
              <span className="subtitle">ARTISAN ONBOARDING</span>
              <h2 className="title">Register New Vendor</h2>
            </div>
            <BackButton onClick={() => navigate("/dash-vendor")}>
              <Icon icon="mdi:arrow-left" size={18} />
              <span>Back to List</span>
            </BackButton>
          </HeaderRow>

          <FormCard>
            <FormTitle>
              <Icon icon="mdi:storefront-plus" className="icon" />
              <span>Artisan Cooperative Credentials</span>
            </FormTitle>
            <form onSubmit={handleSubmit}>
              <FormGrid>
                <FormGroup>
                  <label>Cooperative / Artisan Name <sup className="req">*</sup></label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. Aranmula Heritage Weavers"
                    value={formData.vendor_name}
                    onChange={(e) => setFormData({ ...formData, vendor_name: e.target.value })}
                  />
                </FormGroup>

                <FormGroup>
                  <label>Core Craft Category</label>
                  <select
                    value={formData.category}
                    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  >
                    <option value="Spices & Aromatics">Spices &amp; Aromatics</option>
                    <option value="Ayurveda & Wellness">Ayurveda &amp; Wellness</option>
                    <option value="Handlooms & Garments">Handlooms &amp; Garments</option>
                    <option value="Savory & Crispy">Savory &amp; Crispy</option>
                    <option value="Kerala Heritage Decor">Kerala Heritage Decor</option>
                  </select>
                </FormGroup>

                <FormGroup>
                  <label>Primary Business Email <sup className="req">*</sup></label>
                  <input
                    type="email"
                    required
                    placeholder="e.g. contact@aranmulaheritage.in"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </FormGroup>

                <FormGroup>
                  <label>Mobile Number <sup className="req">*</sup></label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. +91 94471 22334"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                </FormGroup>

                <FormGroup>
                  <label>Platform Commission Rate (%)</label>
                  <input
                    type="number"
                    min="5"
                    max="30"
                    placeholder="10"
                    value={formData.commission_rate}
                    onChange={(e) => setFormData({ ...formData, commission_rate: e.target.value })}
                  />
                </FormGroup>

                <FormGroup>
                  <label>GSTIN / Tax Registration</label>
                  <input
                    type="text"
                    placeholder="32AAAAA1111A1Z1"
                    value={formData.gstin}
                    onChange={(e) => setFormData({ ...formData, gstin: e.target.value })}
                  />
                </FormGroup>

                <FormGroup className="full-width">
                  <label>Origin Address / Workshop Location</label>
                  <textarea
                    rows={3}
                    placeholder="Aranmula Craft Village, Pathanamthitta, Kerala 689533"
                    value={formData.company_address}
                    onChange={(e) => setFormData({ ...formData, company_address: e.target.value })}
                  />
                </FormGroup>

                <FormGroup className="full-width">
                  <label>Verification Document (Artisan Certificate / Cooperative Registration)</label>
                  <FileInputWrapper>
                    <Icon icon="mdi:cloud-upload-outline" className="upload-icon" />
                    <span>Click to Upload PDF or JPG Certificate</span>
                    <input
                      type="file"
                      onChange={(e) => setFormData({ ...formData, artisan_cert: e.target.files[0] })}
                    />
                  </FileInputWrapper>
                </FormGroup>
              </FormGrid>

              <FormActions>
                <button type="button" className="cancel-btn" onClick={() => navigate("/dash-vendor")}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  Onboard Cooperative
                </button>
              </FormActions>
            </form>
          </FormCard>
        </MainPanel>
      </DashboardContainer>
    </>
  );
}

// Styled Components
const DashboardContainer = styled.div`
  display: flex;
  background: #FDFBF7;
  min-height: 100vh;
  font-family: "Jost", sans-serif;
  margin-top: 110px;
`;

const MainPanel = styled.div`
  flex: 1;
  padding: 40px;
  background: #FDFBF7;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(197, 168, 128, 0.15);
  padding-bottom: 20px;

  .subtitle {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #c5a880;
  }

  .title {
    font-family: "Playfair Display", serif;
    font-size: 32px;
    font-weight: 700;
    color: #123524;
    margin: 5px 0 0;
  }
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: #123524;
  border: 2px solid #123524;
  border-radius: 50px;
  padding: 10px 24px;
  font-family: "Jost", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    background: #123524;
    color: #FDFBF7;
    box-shadow: 0 4px 12px rgba(18, 53, 36, 0.15);
  }
`;

const FormCard = styled.div`
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 8px 30px rgba(45, 31, 24, 0.02);
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const FormTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Playfair Display", serif;
  font-size: 22px;
  font-weight: 700;
  color: #123524;
  margin: 0 0 30px 0;
  border-bottom: 1px dashed rgba(197, 168, 128, 0.2);
  padding-bottom: 15px;

  .icon {
    font-size: 26px;
    color: #D4AF37;
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;

  &.full-width {
    grid-column: span 2;

    @media (max-width: 600px) {
      grid-column: span 1;
    }
  }

  label {
    font-size: 13px;
    font-weight: 600;
    color: #2D1F18;
    margin-bottom: 8px;

    .req {
      color: #dc3545;
    }
  }

  input, select, textarea {
    padding: 12px 16px;
    border: 1px solid rgba(197, 168, 128, 0.3);
    border-radius: 8px;
    background: #FFF;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    color: #2D1F18;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #123524;
      box-shadow: 0 4px 12px rgba(18, 53, 36, 0.05);
    }
  }

  textarea {
    resize: none;
  }
`;

const FileInputWrapper = styled.div`
  position: relative;
  border: 2px dashed rgba(197, 168, 128, 0.35);
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  background: #FDFBF7;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #D4AF37;
    background: rgba(212, 175, 55, 0.02);
  }

  .upload-icon {
    font-size: 32px;
    color: #c5a880;
  }

  span {
    font-size: 13px;
    color: #666;
  }

  input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
`;

const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 30px;
  border-top: 1px solid rgba(197, 168, 128, 0.15);
  padding-top: 20px;

  button {
    padding: 12px 30px;
    border-radius: 50px;
    font-family: "Jost", sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .cancel-btn {
    background: transparent;
    color: #777;
    border: 1px solid #ddd;

    &:hover {
      background: rgba(0, 0, 0, 0.03);
      border-color: #999;
    }
  }

  .submit-btn {
    background: linear-gradient(135deg, #123524 0%, #0d261a 100%);
    color: #FDFBF7;
    border: none;
    box-shadow: 0 4px 12px rgba(18, 53, 36, 0.15);

    &:hover {
      background: linear-gradient(135deg, #D4AF37 0%, #C5A880 100%);
      color: #123524;
      box-shadow: 0 6px 16px rgba(197, 168, 128, 0.25);
    }
  }
`;

export default DashboardVendorList;
